import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { InterestedStudiesForm } from "components/InterestedStudiesForm";
import { ContactDetails } from "components/ContactDetails";
import { PopupModal } from "components/Popup";

import "./style.scss";

export const InterestedStudiesContact = ({ labels }) => {
  const [show, setShow] = useState(false);
  const handleShowModal = (show) => setShow(show);
  return (
    <Container className="interested-studies-contact">
      <Row>
        <Col role="h1"  aria-label={labels.title} sm={12} className="title">{labels.title}</Col>
        <Col sm={12} className="sub-title">{labels.sub_title}</Col>
        <Col sm={12} md={6} className="form-area">
          <Container className="form-container">
            {!Utils.isMobile() && <h2 className="form-title">{labels.form_title}</h2>}
            <InterestedStudiesForm values={{...labels, ...labels.InterestedStudies.labels}} showModal={handleShowModal}></InterestedStudiesForm>
          </Container>
        </Col>
        <Col sm={12} md={6} className="form-area">
          <ContactDetails values={labels}></ContactDetails>
        </Col>
      </Row>
      <PopupModal className='popup-modal' show={show} labels={labels} showModal={handleShowModal} />
    </Container>
  );
};
